import { render, staticRenderFns } from "./PanelAhorro.vue?vue&type=template&id=b52e259a&"
import script from "./PanelAhorro.vue?vue&type=script&lang=js&"
export * from "./PanelAhorro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports